import { DeliveriesRoute } from 'app/main/inventoryManagement/routes';
import { PageBreadcrumb } from 'framework/components/breadcrumbs/PageBreadcrumb';
import { PageBreadcrumbDivider } from 'framework/components/breadcrumbs/PageBreadcrumbDivider';
import { PageBreadcrumbTitle } from 'framework/components/breadcrumbs/PageBreadcrumbTitle';
import { IDelivery } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { PageReloadButtonX } from 'framework/components/layout/PageReloadButtonX';
import { StockTransactionTabIconRecord } from '../../StockTransactionTabIconRecord';
import { PageXHeaderActions } from 'framework/components/layout/PageXHeaderActions';

interface IProps {
	item: IDelivery;
	reload: VoidFunction;
}

export const DeliveryDetailPageHeader = ({ item, reload }: IProps) => {
	const strings = useLocalization();

	return (
		<div
			className='df-row-ac fg1'
			style={{ paddingBottom: 16 }}>
			<PageBreadcrumbTitle title={strings.inventoryManagementShortened} />
			<PageBreadcrumbDivider />
			<PageBreadcrumbTitle title={strings.stockTransactions} />
			<PageBreadcrumbDivider />
			<PageBreadcrumb
				text={strings.deliveries}
				route={DeliveriesRoute}
				icon={StockTransactionTabIconRecord['deliveries']}
			/>
			<PageBreadcrumbDivider />
			<PageBreadcrumbTitle title={item.reference} />
			<div className='fg1'></div>
			<PageXHeaderActions>
				<PageReloadButtonX reload={reload} />
			</PageXHeaderActions>
		</div>
	);
};
